// Import Bootstrap FIRST so custom styles can override it
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import "./assets/styles/base/rootStyles.css";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './components/LoginPage/LoginPage';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import NotAuthorized from './components/NotAuthorized/NotAuthorized';
import NotFound from './components/NotFound/NotFound';
import { theme } from "./customTheme";
// import { QueryClient, QueryClientProvider } from "react-query";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@emotion/react";

import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import { DashboardProvider } from './contexts/DashboardContext';
import RegisterAgent from './components/Agent/RegisterEdit/RegisterAgent';
import EditAgent from './components/Agent/RegisterEdit/EditAgent';
import SolutionDashboard from './components/Solutions/DashboardSolution/SolutionsDashboard';
import RegisterSolution from './components/Solutions/RegisterEdit/RegisterSolution';
import { SolutionsProvider } from './contexts/SolutionsContext';
import Settings from './components/Settings/Settings';
import EditSolution from './components/Solutions/RegisterEdit/EditSolution';
import { AgentsProvider } from './contexts/AgentsContext';
import AgentDashboard from './components/Agent/AgentDashboard';

const queryClient = new QueryClient();
function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <div className="App">
            <Router>
              <Header />

              <div className="content-area">
                <Routes>
                  <Route path="/" element={<LoginPage />} />

                  {/* Agents */}
                  <Route path="/agents/*" element={
                    <ProtectedRoute>
                      <DashboardProvider>
                        <AgentsProvider>
                            <Routes>
                              <Route path="/" element={<AgentDashboard />} />
                              <Route path="/register-agent" element={<RegisterAgent />} />
                              <Route path="/edit-agent/:id" element={<EditAgent />} />
                              <Route path="/edit-agent" element={<EditAgent />} />
                              <Route path="*" element={<NotFound />} />
                            </Routes>
                        </AgentsProvider>
                      </DashboardProvider>
                    </ProtectedRoute>
                  } />

                  {/* Solutions */}
                  <Route path="/solutions/*" element={
                    <ProtectedRoute>
                      <DashboardProvider>
                        <SolutionsProvider>
                          <Routes>
                            <Route path="/" element={<SolutionDashboard />} />
                            <Route path="/register-solution" element={<RegisterSolution />} />
                            <Route path="/edit-solution/:id" element={<EditSolution />} />
                            <Route path="/edit-solution" element={<EditSolution />} />
                            <Route path="*" element={<NotFound />} />
                          </Routes>
                        </SolutionsProvider>
                      </DashboardProvider>
                    </ProtectedRoute>
                  } />

                  {/* Settings */}
                  <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                  <Route path="/not-authorize" element={<NotAuthorized />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>

              </div>

              <Footer />
            </Router>
          </div>
        </ThemeProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
